import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { showToast } from 'utils/utility';
import { useApi } from 'libs/data-access/src/api/useApi';
import { IAffiliateAddCredits, IAffiliateList } from 'types';

export const defaultCreditLimit: IAffiliateAddCredits = {
    affiliateId: null,
    creditLimit: null,
    remainingCredit:null,
    validity: ''
}

const UseManageAffiliates = () => {
    const {
        patchData
    } = useApi();

    const { state } = useLocation();

    const [isBtnLoading, setIsBtnLoading] = React.useState(false);
    const [selectedAffiliate, setSelectedAffiliate] = useState<IAffiliateList>(state);
    const [editAccountCredit, setEditAccountCredit] = useState<IAffiliateAddCredits>(defaultCreditLimit);
    const [addedCredits,setAddedCredits]=useState<string| number>("0")

    useEffect(() => {
        setEditAccountCredit({
            affiliateId: selectedAffiliate.id,
            creditLimit: addedCredits? Number(addedCredits) : 0,
            remainingCredit:selectedAffiliate.remainingCredit,
            validity: selectedAffiliate.validity
        });
    }, [addedCredits]);

     const handleUpdateAffiliateWithCredits = async () => {
        setIsBtnLoading(true);
         const response = await patchData('affiliate/add-credit-details', editAccountCredit);
         if (response.isSuccess) {
            showToast({
                message: "Credits Update Successfully",
                type: "success",
            })
            setAddedCredits("0");
            // window.location.reload();
            setSelectedAffiliate(prev => ({
                ...prev,
                creditLimit: (prev.creditLimit ?? 0) + (editAccountCredit.creditLimit ?? 0),
                remainingCredit:(prev.remainingCredit ?? 0) + (editAccountCredit.creditLimit ?? 0),
                validity: editAccountCredit.validity
            }));
          }
        else{
            showToast({
                message: response.message,
                type: "error",
            });
        };
        setIsBtnLoading(false);
     }

    return {
        addedCredits,setAddedCredits,
        isBtnLoading,
        selectedAffiliate,
        editAccountCredit,
        setEditAccountCredit,
        handleUpdateAffiliateWithCredits
    };
};

export default UseManageAffiliates;
